// extracted by mini-css-extract-plugin
export default {"contactsBanner":"yhDgRVNpw8gKWP2AgWTw","contactsBannerIcon":"NaoOx5ojoue0hHNdKCb4","contactsBannerLink":"RcppjdFu4iguzGCDuSoX","contactsBannerClose":"K4zyla7ozmwRgqFB4DCb"};